import { Portlet, PortletBody, PortletHeader } from '@energytoolbase/components'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { MY_PROFILE_ROUTE } from 'router/routes'
import { Error } from 'components/common/error'

export function NotFound(): JSX.Element {
  const navigate = useNavigate()

  return (
    <Portlet>
      <PortletHeader title='Not Found' />
      <PortletBody>
        <Error
          message='This URL route does not exist. Use the button below to go to your profile page.'
          retryButtonText='My Profile'
          onRetry={(): void => navigate(MY_PROFILE_ROUTE)}
        />
      </PortletBody>
    </Portlet>
  )
}
